let CategoryPromoSlider = {},
    // isInitialized = false,
    $categoryPromoSlider, $slider;

CategoryPromoSlider = {
    init() {
        $categoryPromoSlider = $('.js-category-promo-slider');

        if ($categoryPromoSlider.length === 0) {
            return;
        }

        $.each($categoryPromoSlider, function () {
			$slider = $(this);
			let sliderItemLength = $slider.find('.categoryPromo-item').length;

            $slider.flickity({
				cellAlign: 'center',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
				dragThreshold: 10,
                on: {
                    ready: function () {
                        if (sliderItemLength > 3) {
							$slider.addClass('is-multiple');
						}
                    },
                },
            });
        });
    },
}

$(function () {
    CategoryPromoSlider.init();

    $(window).resize(function () {
        CategoryPromoSlider.init();
    });

});

window.CategoryPromoSlider = CategoryPromoSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/category-promo-slider.js